import { MdThumbUp, MdThumbDown, MdVisibility, MdComment } from "react-icons/md";
import "./reactiontooltip.scss";
import { useEffect, useState } from "react";
import { BsStars } from "react-icons/bs";
import { UpdatePostLike, UpdatePostUnLike, UpdateViewCount } from "services/blogs/blogs";

const ReactionToolTip = ({ postid, like, dislikes, views, comments }) => {
    const [liked, setLiked] = useState(false);
    const [likecount, setlikecount] = useState(like);
    const [UnlikeCount, setUnLikeCount] = useState(dislikes);
    const [unliked, setunLiked] = useState(false);
    const [currentIP, setCurrentIP] = useState(null);
    const storedIP = localStorage.getItem("user_ip");
    // const storedIP = "33";

    // Sync like prop with local state when it changes

    useEffect(() => {
        setlikecount(like);
    }, [like]);

    useEffect(() => {
    }, [liked]);

    useEffect(() => {
        setUnLikeCount(dislikes);
    }, [dislikes]);

    useEffect(() => {
    }, [unliked]);


    const handlePostLike = async () => {
        try {
            let ip = localStorage.getItem("user_ip")
            // let ip = "33.45.61"
            const res = await UpdatePostLike({
                postid: postid,
                ipaddress: ip,
            });

            if (res.code === 200) {
                setLiked(true)

                setlikecount(res.data.likecount)

            } else {
                // console.log("failed");
            }
        } catch (err) {
            // console.log("failed");
        } finally {
            // console.log("finished");
        }


    };

    const handlePostDisLike = async () => {
        try {
            let ip = localStorage.getItem("user_ip")
            // let ip = "33.45.61"
            const res = await UpdatePostUnLike({
                postid: postid,
                ipaddress: ip,
            });

            if (res.code === 200) {
                setunLiked(true)

                setUnLikeCount(res.data.dislikescount)

            } else {
                // console.log("failed");
            }
        } catch (err) {
            // console.log("failed");
        } finally {
            // console.log("finished");
        }


    };



    useEffect(() => {
        const checkIPChange = async () => {
            try {
                const res = await fetch("https://api.ipify.org?format=json");
                const data = await res.json();
                setCurrentIP(data.ip);
            } catch (error) {
                console.error("Failed to fetch IP address", error);
            }
        };

        checkIPChange();
    }, []);




    const checkGreaterThanTwoDigit = like > 99 || dislikes > 99 || views > 99;

    return (
        <div className="reaction-wrapper">
            <div
                className="reactiontoolcontainer"
                style={checkGreaterThanTwoDigit ? { left: "-500%" } : undefined}
            >
                <div
                    className={`reaction-row-like ${liked ? "liked" : ""}`}
                    onClick={handlePostLike}
                >
                    <MdThumbUp size={16} />
                    <span>{likecount}</span>
                    {liked && <span className="sparkle"><BsStars /></span>}
                </div>

                <div
                    className={`reaction-row-dislike ${unliked ? "liked" : ""}`}
                    onClick={handlePostDisLike}
                >
                    <MdThumbDown size={16} />
                    {/* <span>{UnlikeCount}</span> */}
                    {unliked && <span className="sparkle"><BsStars /></span>}
                </div>

                <div className="reaction-row-view">
                    <MdVisibility size={16} /> <span>{views}</span>
                </div>
                <div className="reaction-row-comment">
                    <MdComment size={16} /> <span>{comments}</span>
                </div>
            </div>
        </div>
    );
};

export default ReactionToolTip;
